import { render, staticRenderFns } from "./DiscussionUpdate.vue?vue&type=template&id=66415efc&"
import script from "./DiscussionUpdate.vue?vue&type=script&lang=js&"
export * from "./DiscussionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports